import { render, staticRenderFns } from "./AIChatWidgetRadio.vue?vue&type=template&id=1cf1c1c2&scoped=true"
import script from "./AIChatWidgetRadio.vue?vue&type=script&lang=js"
export * from "./AIChatWidgetRadio.vue?vue&type=script&lang=js"
import style0 from "./AIChatWidgetRadio.vue?vue&type=style&index=0&id=1cf1c1c2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cf1c1c2",
  null
  
)

export default component.exports